<template>
<div class="content" >
  <div class="login__wrapper" @keyup.enter="onConfirmVerification">
    <div class="mobile-block">
      <div class="mobile-logo">
        <svg width="150" height="40" viewBox="0 0 224 62" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.1497 28.3975C31.9716 26.8495 32.3097 25.1024 32.4698 23.4052C32.7088 20.8707 32.8517 18.3853 31.8661 15.9446C30.7754 13.2435 30.6095 10.3595 30.5447 7.473C30.5319 6.9049 30.5429 6.33625 30.2906 5.73191C29.9447 6.95374 29.8702 8.38163 29.9681 9.64712C30.1857 12.4633 28.7857 14.9031 28.3949 17.5535C28.1109 19.4798 28.2824 21.4851 28.3263 23.4533C28.3602 24.9772 28.7052 26.4553 27.8349 27.9474C27.2881 28.8849 27.025 30.1146 26.9822 31.2275C26.871 34.121 26.9758 37.0227 26.9353 39.9203C26.9272 40.4993 26.7612 41.1347 26.4877 41.6401C25.601 43.2784 24.2608 44.7636 23.7972 46.5068C23.3432 48.2137 23.7516 50.1645 23.7762 52.0083C23.7848 52.6533 23.7775 53.2986 23.7775 53.9951C24.3622 53.9951 24.8695 53.9951 25.4888 53.9951C25.4888 51.8299 25.4888 49.6734 25.4888 47.4392C26.4187 47.4392 27.2398 47.4392 28.2131 47.4392C28.2131 48.4447 28.2881 49.4738 28.1953 50.4866C28.06 51.963 28.148 52.1471 29.665 52.3864C29.2207 55.0856 28.7777 57.7844 28.3301 60.4823C28.3017 60.6532 28.2386 60.8178 28.1951 60.9733C16.9917 60.7968 4.7124 52.7718 1.10243 38.6337C0.430959 36.004 -0.167709 32.5245 0.0428891 30.676C1.25462 27.8604 2.24287 24.0483 5.93909 23.2821C5.93909 28.0664 9.36748 32.6855 14.8239 31.3886C18.5798 30.496 21.0991 26.4509 20.4792 22.4926C19.8534 18.4967 15.5953 14.5412 10.3215 16.5316C10.0243 16.23 9.48488 15.7697 9.52843 15.6145C10.3321 12.7504 11.2216 10.7221 11.0983 7.73307C15.3032 4.21629 20.1438 1.99036 25.5019 1.23353C34.0161 0.030913 41.8851 1.88813 48.7084 7.31569C56.6677 13.6468 60.6781 22.1063 60.1965 32.5728C59.5572 46.4645 49.4476 58.1641 36.1633 60.5538C34.8956 60.7818 33.6132 60.9223 32.2346 61.1181C31.7878 58.1232 31.3633 55.2777 30.9256 52.3433C32.7903 52.0193 32.5703 52.2046 32.6826 50.4656C32.6826 49.9561 32.7838 47.616 32.8201 47.4323C33.5809 47.4323 34.4044 47.4323 35.331 47.4323C35.331 49.6018 35.331 51.7583 35.331 53.9719C35.9702 53.9719 36.5087 53.9719 37.1643 53.9719C37.1643 51.554 37.1844 49.1708 37.1425 46.7888C37.1362 46.4318 36.8615 46.0669 36.6729 45.7282C35.7001 43.981 34.7148 42.241 33.7331 40.3673C33.7206 40.1995 33.7091 40.1631 33.6975 40.1266C33.7136 39.0335 33.7298 37.9403 33.7427 36.693C33.5703 34.5442 33.7293 32.3258 33.7269 30.1658C33.6328 29.5953 33.4947 28.8509 33.1497 28.3975ZM52.7131 43.0711C53.4497 41.0199 52.8904 39.1414 51.1552 37.8382C49.6671 36.7206 47.6331 36.7737 46.1843 37.968C44.6156 39.2611 44.0739 41.268 44.8649 43.1003C45.5685 44.7301 46.8515 45.6169 48.5552 45.6971C50.3944 45.7837 51.773 44.9083 52.7131 43.0711ZM46.0215 23.7923C44.9253 24.5673 44.2301 25.5792 44.1225 26.9961C44.0026 28.5749 44.9598 30.3724 46.4226 31.1958C47.784 31.9622 49.6477 31.7865 50.8645 30.7772C52.3059 29.5816 52.9077 27.8011 52.4223 26.1675C51.6107 23.4355 48.6845 22.2822 46.0215 23.7923ZM42.3012 11.0834C40.3095 10.1752 38.2729 11.2221 38.099 13.2435C37.9797 14.6295 38.8511 16.0549 40.0221 16.389C41.3745 16.7749 42.8297 16.1658 43.4558 14.9519C44.153 13.6 43.7996 12.2994 42.3012 11.0834ZM11.6987 40.3308C10.6516 40.1444 9.93367 40.5421 9.62815 41.4815C9.31864 42.4332 9.62479 43.1945 10.4045 43.7204C11.1827 44.2455 11.9358 44.0893 12.5745 43.415C13.2142 42.7396 13.2121 41.8292 12.5874 40.9686C12.3926 40.7002 12.0308 40.39 11.6987 40.3308ZM46.3484 50.9321C46.6814 50.1068 46.2809 49.4823 45.601 49.3389C45.1501 49.2437 44.4132 49.5567 44.1229 49.9426C43.7397 50.4521 43.9548 51.139 44.566 51.5044C45.2482 51.9121 45.8351 51.7291 46.3484 50.9321ZM21.4713 14.71C21.8325 14.4885 22.1937 14.2671 22.5549 14.0456C22.3674 13.7418 22.2376 13.279 21.9766 13.1781C21.7083 13.0743 21.3119 13.3238 20.9716 13.4187C21.0885 13.8363 21.2055 14.2539 21.4713 14.71ZM19.3449 36.3729C18.9431 36.5215 18.5412 36.6702 18.1393 36.8188C18.2626 37.1616 18.2965 37.6527 18.5343 37.8056C18.7739 37.9596 19.4779 37.8629 19.5196 37.7264C19.6378 37.3401 19.5211 36.8771 19.3449 36.3729ZM18.2691 52.6277C18.165 52.2404 18.1161 51.8177 17.9189 51.4901C17.8681 51.4057 17.2671 51.5321 17.0751 51.7264C16.9252 51.8781 16.9325 52.5054 17.0163 52.5397C17.3645 52.682 17.7681 52.6796 18.2691 52.6277Z" fill="black"/>
          <path d="M5.93918 23.501C3.87919 24.0579 0.885284 32.8709 0.0429688 30.6962C0.124564 25.8055 1.27293 21.0992 3.62851 16.7596C5.06414 14.1147 6.87463 11.7973 8.90824 9.64982C9.53808 8.98468 10.426 8.24499 11.2036 7.64453C11.2946 8.11223 11.2329 8.78604 11.3089 9.25686C11.7127 11.757 10.7066 13.2262 10.0455 15.5821C10.1508 16.3433 11.3089 16.017 9.72959 16.8683C7.33812 18.4047 5.93918 21.1089 5.93918 23.501Z" fill="black"/>
          <path d="M100.978 19.6748C103.806 19.6748 106.633 19.6748 109.623 19.6748C109.623 20.8249 109.623 21.986 109.623 23.147C109.764 23.233 109.906 23.319 110.047 23.405C110.301 23.0407 110.507 22.633 110.814 22.3185C114.906 18.1213 120.596 18.0443 124.847 22.1138C131.179 28.1756 128.97 39.5437 120.81 42.8936C117.218 44.368 113.937 43.674 111.294 40.8818C110.817 40.3778 110.336 39.877 109.639 39.1465C109.639 41.5237 109.591 43.6603 109.662 45.7931C109.692 46.6831 109.418 47.2 108.637 47.677C106.136 49.2046 103.693 50.8215 101.008 52.5449C101.008 50.6539 101.008 49.0058 101.006 47.1074C100.996 37.7964 100.987 28.7356 100.978 19.6748ZM111.632 27.8585C111.416 28.2139 111.168 28.5544 110.99 28.9269C109.284 32.4914 111.662 36.7347 115.42 36.8472C117.84 36.9196 119.846 35.474 120.585 33.125C121.311 30.818 120.225 27.9434 118.155 26.6975C116.036 25.4219 113.836 25.7671 111.632 27.8585Z" fill="black"/>
          <path d="M200.195 38.9255C196.224 33.4798 196.845 26.5303 201.598 22.408C206.747 17.9434 214.847 17.9326 219.829 22.4485C223.648 25.9104 224.924 30.2069 223.326 35.0324C221.674 40.0203 217.996 43.0045 212.667 43.7819C207.643 44.5146 203.481 42.8719 200.195 38.9255ZM207.342 35.7055C209.759 37.3941 212.353 37.2782 214.412 35.3897C216.268 33.6867 216.576 30.6168 215.112 28.3955C213.739 26.3116 210.976 25.4282 208.664 26.3332C204.705 27.8825 204.431 33.3107 207.342 35.7055Z" fill="black"/>
          <path d="M136.758 38.9255C132.787 33.4798 133.407 26.5303 138.161 22.408C143.309 17.9434 151.409 17.9326 156.391 22.4485C160.21 25.9104 161.486 30.2069 159.888 35.0324C158.237 40.0203 154.559 43.0045 149.229 43.7819C144.206 44.5146 140.043 42.8719 136.758 38.9255ZM143.904 35.7055C146.321 37.3941 148.915 37.2782 150.974 35.3897C152.831 33.6867 153.138 30.6168 151.675 28.3955C150.302 26.3116 147.539 25.4282 145.226 26.3332C141.267 27.8825 140.993 33.3107 143.904 35.7055Z" fill="black"/>
          <path d="M94.2145 24.9533C94.4254 28.1833 94.6363 31.4133 94.8481 34.8984C94.8468 36.9272 94.873 38.7015 94.8303 40.4742C94.809 41.3603 94.6621 42.2435 94.572 43.1281C91.7063 43.1281 88.8407 43.1281 85.8652 43.1281C85.8652 41.9244 85.8652 40.8395 85.8652 39.7546C85.7697 39.693 85.6742 39.6314 85.5787 39.5699C85.1567 40.0268 84.7516 40.5002 84.3096 40.9377C82.8674 42.3652 81.1072 43.2314 79.0872 43.4635C76.265 43.7877 73.9187 42.8743 72.5037 40.382C71.1068 37.9216 71.1834 35.4123 72.9179 33.0942C75.3663 29.8219 78.8723 28.2572 82.7924 27.4137C83.4804 27.2656 84.1802 27.17 84.8719 27.0506C84.6694 24.1989 81.7599 23.7069 76.7552 25.656C74.7237 22.5114 74.5649 22.8977 77.7778 21.1196C82.6271 18.4361 88.1912 18.8071 91.9639 21.9224C92.4406 22.3676 92.7941 22.6961 93.1476 23.0247C93.1476 23.0247 93.1623 22.9948 93.1632 23.0971C93.5142 23.7839 93.8643 24.3686 94.2145 24.9533ZM85.1813 32.6899C85.1813 31.9745 85.1813 31.2591 85.1813 30.2417C83.7396 30.6336 82.3923 30.8537 81.1751 31.3685C79.7005 31.9922 78.8622 33.2241 78.7769 34.8379C78.7142 36.0219 79.0923 37.106 80.2479 37.5943C81.376 38.0709 82.4567 37.7078 83.3507 36.8687C84.4967 35.7931 85.0009 34.4424 85.1813 32.6899Z" fill="black"/>
          <path d="M175.334 26.0166C175.334 31.7778 175.334 37.4002 175.334 43.1014C172.337 43.1014 169.435 43.1014 166.333 43.1014C166.333 42.6254 166.333 42.1388 166.333 41.6522C166.333 33.341 166.351 25.0296 166.31 16.7186C166.305 15.7725 166.605 15.206 167.396 14.6982C170.021 13.0127 172.604 11.2654 175.334 9.45508C175.334 15.0299 175.334 20.4539 175.334 26.0166Z" fill="black"/>
          <path d="M191.262 10.8677C191.262 21.666 191.262 32.3394 191.262 43.0923C188.248 43.0923 185.34 43.0923 182.301 43.0923C182.274 42.7184 182.219 42.3241 182.219 41.9298C182.222 33.5593 182.242 25.1888 182.22 16.8184C182.218 16.0003 182.418 15.4734 183.145 15.001C185.808 13.2704 188.422 11.4677 191.262 9.55273C191.262 10.0676 191.262 10.4052 191.262 10.8677Z" fill="black"/>
        </svg>
      </div>
      <LanguageSwitcher />
    </div>
    <div class="lang-change-trigger">
      <LanguageSwitcher />
    </div>
    <div class="twoFactor">
      <h1 class="twoFactor__title">{{ $t('authorization.verif-title') }}</h1>
      <h2 class="twoFactor__subtitle">{{ $t('authorization.verification-description') }}</h2>
      <div class="login-input__wrapper">
        <label class="login-input__label" for="Code">{{ $t('authorization.enter-code') }}</label>
        <input class="login-input" name="Code" v-model="twoFactorCode" :placeholder="$t('authorization.code')" maxlength="15" />
      </div>
      <div v-if="errorCode" class="error-banner">
        <svg class="error-banner__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.80977 0.21967C6.95042 0.0790176 7.14118 0 7.3401 0H16.6599C16.8588 0 17.0496 0.0790176 17.1902 0.21967L23.7803 6.80977C23.921 6.95042 24 7.14118 24 7.3401V16.6599C24 16.8588 23.921 17.0496 23.7803 17.1902L17.1902 23.7803C17.0496 23.921 16.8588 24 16.6599 24H7.3401C7.14118 24 6.95042 23.921 6.80977 23.7803L0.21967 17.1902C0.0790176 17.0496 0 16.8588 0 16.6599V7.3401C0 7.14118 0.0790176 6.95042 0.21967 6.80977L6.80977 0.21967ZM7.65076 1.5L1.5 7.65076V16.3492L7.65076 22.5H16.3492L22.5 16.3492V7.65076L16.3492 1.5H7.65076Z" fill="#BE4040"/>
          <path d="M10.5023 16.5C10.5023 15.6716 11.1739 15 12.0023 15C12.8307 15 13.5023 15.6716 13.5023 16.5C13.5023 17.3284 12.8307 18 12.0023 18C11.1739 18 10.5023 17.3284 10.5023 16.5Z" fill="#BE4040"/>
          <path d="M10.6493 7.49256C10.5693 6.69343 11.1969 6 12 6C12.8031 6 13.4307 6.69343 13.3507 7.49256L12.8246 12.7537C12.7823 13.1774 12.4258 13.5 12 13.5C11.5742 13.5 11.2177 13.1774 11.1754 12.7537L10.6493 7.49256Z" fill="#BE4040"/>
        </svg>
        <span class="error-banner__text">{{ errorMsg }}</span>
      </div>
      <NButton @click="onConfirmVerification"  class="twoFactor__btn">{{ $t('authorization.send') }}</NButton>
      <p class="twoFactor__logout"><a href="/logout" class="login-description__link">{{ $t('authorization.logout') }}</a></p>
    </div>
  </div>
  <div class="logo-wrapper">
    <svg width="527" height="442" viewBox="0 0 527 442" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_17996_8007)">
        <path d="M114.261 309.023C122.435 309.023 130.609 309.023 139.249 309.023C139.249 312.419 139.249 315.847 139.249 319.275C139.658 319.529 140.067 319.783 140.477 320.037C141.208 318.961 141.806 317.757 142.692 316.829C154.521 304.436 170.967 304.209 183.254 316.224C201.556 334.122 195.172 367.687 171.584 377.578C161.202 381.931 151.72 379.882 144.079 371.638C142.7 370.15 141.311 368.671 139.297 366.514C139.297 373.533 139.158 379.842 139.364 386.139C139.45 388.767 138.656 390.293 136.4 391.701C129.172 396.212 122.109 400.985 114.348 406.074C114.348 400.491 114.348 395.625 114.344 390.019C114.314 362.528 114.287 335.776 114.261 309.023ZM145.056 333.186C144.432 334.235 143.715 335.241 143.2 336.341C138.27 346.865 145.144 359.393 156.006 359.725C163 359.939 168.799 355.671 170.936 348.736C173.035 341.924 169.893 333.437 163.911 329.758C157.787 325.992 151.428 327.011 145.056 333.186Z" fill="#FDFAEF"/>
        <path d="M401.045 365.857C389.566 349.779 391.36 329.26 405.101 317.089C419.982 303.907 443.394 303.875 457.794 317.208C468.833 327.43 472.521 340.115 467.902 354.363C463.128 369.09 452.497 377.901 437.093 380.196C422.573 382.36 410.541 377.509 401.045 365.857ZM421.702 356.35C428.687 361.336 436.185 360.994 442.137 355.418C447.503 350.39 448.391 341.326 444.161 334.767C440.193 328.614 432.207 326.006 425.523 328.678C414.08 333.252 413.287 349.279 421.702 356.35Z" fill="#FDFAF0"/>
        <path d="M284.271 339.932C284.784 355.445 278.352 367.085 265.53 374.705C252.558 382.414 239.04 382.405 225.953 374.646C213.433 367.225 206.418 350.715 209.336 336.482C212.548 320.808 224.146 309.783 239.762 307.56C259.961 304.684 277.804 315.552 283.069 333.979C283.59 335.804 283.857 337.702 284.271 339.932ZM234.817 332.208C234.122 333.213 233.321 334.161 232.748 335.232C227.181 345.646 233.655 358.71 244.682 359.368C252.056 359.809 258.358 355.751 260.634 349.098C262.975 342.253 260.223 333.814 254.35 329.83C248.445 325.825 241.282 326.556 234.817 332.208Z" fill="#FDFAEF"/>
        <path d="M94.7139 324.605C95.3236 334.141 95.9332 343.678 96.5455 353.968C96.5418 359.958 96.6173 365.197 96.4941 370.431C96.4325 373.047 96.0078 375.655 95.7473 378.266C87.4644 378.266 79.1815 378.266 70.5809 378.266C70.5809 374.713 70.5809 371.509 70.5809 368.306C70.3049 368.124 70.0289 367.942 69.7529 367.761C68.5331 369.11 67.3623 370.507 66.0847 371.799C61.916 376.014 56.8284 378.572 50.9896 379.257C42.8324 380.214 36.0505 377.517 31.9605 370.159C27.9228 362.894 28.1443 355.485 33.1576 348.641C40.2347 338.979 50.3685 334.359 61.6992 331.869C63.6879 331.432 65.7106 331.149 67.71 330.797C67.1246 322.377 58.715 320.925 44.2492 326.679C38.3772 317.395 37.9182 318.535 47.205 313.285C61.2215 305.362 77.3041 306.458 88.2088 315.656C89.5867 316.97 90.6085 317.94 91.6303 318.91C91.6303 318.91 91.6728 318.822 91.6754 319.124C92.6899 321.152 93.7019 322.878 94.7139 324.605ZM68.6042 347.447C68.6042 345.335 68.6042 343.223 68.6042 340.219C64.4372 341.376 60.5428 342.026 57.0245 343.546C52.7623 345.387 50.3393 349.024 50.0926 353.789C49.9116 357.285 51.0043 360.486 54.3447 361.928C57.6054 363.335 60.7288 362.263 63.3131 359.785C66.6255 356.609 68.0826 352.622 68.6042 347.447Z" fill="#FCF8EE"/>
        <path d="M329.185 327.748C329.185 344.758 329.185 361.359 329.185 378.192C320.523 378.192 312.134 378.192 303.167 378.192C303.167 376.787 303.167 375.35 303.167 373.913C303.168 349.374 303.22 324.834 303.1 300.295C303.087 297.502 303.954 295.829 306.24 294.33C313.826 289.354 321.294 284.195 329.185 278.85C329.185 295.31 329.185 311.324 329.185 327.748Z" fill="#FBF8ED"/>
        <path d="M375.222 283.019C375.221 314.902 375.221 346.415 375.221 378.164C366.511 378.164 358.106 378.164 349.322 378.164C349.242 377.06 349.083 375.896 349.083 374.732C349.092 350.017 349.152 325.303 349.088 300.589C349.081 298.173 349.658 296.618 351.76 295.223C359.458 290.113 367.015 284.791 375.222 279.137C375.222 280.657 375.222 281.654 375.222 283.019Z" fill="#FCF8EE"/>
        <path d="M265.656 118.417C261.072 112.584 262.388 106.002 263.011 99.6071C263.941 90.0578 264.497 80.6932 260.662 71.4974C256.418 61.3203 255.772 50.4541 255.52 39.5783C255.47 37.4379 255.513 35.2953 254.531 33.0183C253.185 37.6219 252.896 43.0018 253.276 47.7699C254.123 58.3805 248.676 67.5733 247.155 77.5592C246.05 84.8172 246.717 92.3725 246.888 99.7885C247.02 105.53 248.363 111.099 244.976 116.721C242.849 120.253 241.825 124.887 241.658 129.08C241.226 139.982 241.633 150.915 241.476 161.832C241.444 164.014 240.798 166.408 239.734 168.312C236.284 174.485 231.069 180.081 229.265 186.649C227.499 193.08 229.088 200.43 229.183 207.377C229.217 209.807 229.189 212.238 229.189 214.863C231.464 214.863 233.438 214.863 235.847 214.863C235.847 206.705 235.847 198.58 235.847 190.161C239.466 190.161 242.661 190.161 246.448 190.161C246.448 193.95 246.74 197.828 246.378 201.643C245.852 207.206 246.194 207.9 252.097 208.802C250.369 218.972 248.644 229.14 246.903 239.305C246.793 239.949 246.547 240.569 246.378 241.155C202.785 240.49 155.006 210.254 140.959 156.984C138.346 147.076 136.017 133.966 136.836 127.002C141.551 116.393 145.397 102.03 159.779 99.1432C159.779 117.169 173.119 134.573 194.35 129.687C208.964 126.323 218.767 111.083 216.355 96.1686C213.92 81.113 197.351 66.2097 176.831 73.7091C175.674 72.5725 173.575 70.8385 173.745 70.2536C176.872 59.4623 180.333 51.82 179.853 40.5582C196.215 27.3078 215.05 18.921 235.898 16.0695C269.027 11.5383 299.646 18.5358 326.196 38.9856C357.166 62.8398 372.77 94.7131 370.896 134.149C368.409 186.489 329.072 230.571 277.382 239.574C272.45 240.433 267.46 240.963 262.096 241.701C260.357 230.416 258.705 219.695 257.002 208.639C264.258 207.418 263.402 208.117 263.839 201.565C263.839 199.645 264.232 190.828 264.374 190.136C267.334 190.136 270.538 190.136 274.144 190.136C274.144 198.31 274.144 206.435 274.144 214.775C276.631 214.775 278.726 214.775 281.277 214.775C281.277 205.665 281.355 196.686 281.192 187.711C281.168 186.366 280.099 184.991 279.365 183.715C275.58 177.132 271.746 170.576 267.926 163.516C267.878 162.884 267.833 162.747 267.788 162.609C267.851 158.491 267.913 154.372 267.964 149.672C267.293 141.576 267.912 133.218 267.902 125.08C267.536 122.93 266.999 120.125 265.656 118.417ZM341.778 173.704C344.644 165.975 342.468 158.898 335.716 153.987C329.926 149.776 322.012 149.976 316.374 154.476C310.27 159.349 308.163 166.91 311.241 173.813C313.978 179.954 318.971 183.296 325.599 183.598C332.756 183.924 338.12 180.626 341.778 173.704ZM315.741 101.066C311.475 103.985 308.771 107.798 308.352 113.137C307.885 119.085 311.61 125.858 317.302 128.96C322.599 131.848 329.851 131.186 334.585 127.383C340.194 122.878 342.535 116.17 340.647 110.015C337.489 99.7213 326.103 95.3758 315.741 101.066ZM301.265 53.1814C293.515 49.7597 285.591 53.7041 284.914 61.3203C284.45 66.5425 287.841 71.9131 292.397 73.1719C297.659 74.6256 303.322 72.3308 305.758 67.7571C308.471 62.6633 307.095 57.7629 301.265 53.1814ZM182.19 163.379C178.115 162.676 175.322 164.175 174.133 167.714C172.929 171.3 174.12 174.169 177.154 176.15C180.182 178.128 183.112 177.54 185.597 174.999C188.087 172.455 188.078 169.024 185.647 165.782C184.889 164.771 183.482 163.602 182.19 163.379ZM317.013 203.322C318.309 200.213 316.75 197.86 314.105 197.319C312.35 196.96 309.483 198.14 308.353 199.594C306.862 201.514 307.699 204.102 310.077 205.478C312.732 207.014 315.016 206.325 317.013 203.322ZM220.215 66.8456C221.62 66.0112 223.026 65.1768 224.431 64.3424C223.702 63.1975 223.197 61.454 222.181 61.0737C221.137 60.6828 219.595 61.6227 218.271 61.9803C218.726 63.5537 219.181 65.1272 220.215 66.8456ZM211.941 148.466C210.378 149.026 208.814 149.586 207.25 150.147C207.73 151.438 207.862 153.288 208.787 153.864C209.72 154.445 212.459 154.08 212.621 153.566C213.081 152.11 212.627 150.366 211.941 148.466ZM207.755 209.711C207.35 208.251 207.16 206.659 206.393 205.424C206.195 205.106 203.857 205.583 203.109 206.315C202.526 206.886 202.555 209.25 202.88 209.379C204.235 209.915 205.806 209.906 207.755 209.711Z" fill="#FDFBEF"/>
        <path d="M159.779 99.9624C151.763 102.06 140.114 135.266 136.836 127.072C137.154 108.645 141.622 90.9128 150.788 74.5621C156.374 64.597 163.419 55.8656 171.332 47.7742C173.782 45.2681 177.237 42.4811 180.263 40.2188C180.617 41.9809 180.377 44.5197 180.673 46.2936C182.244 55.7136 178.329 61.249 175.757 70.1258C176.166 72.9936 180.673 71.7643 174.527 74.9716C165.222 80.7606 159.779 90.9493 159.779 99.9624Z" fill="#FDFBEF"/>
        <path d="M247.913 408.281C250.142 410.518 252.146 412.555 254.183 414.625C257.137 411.899 259.913 409.336 263.23 406.275C263.23 412.683 263.23 418.443 263.23 424.634C262.403 424.738 261.284 424.878 259.717 425.075C259.717 421.964 259.717 419.192 259.717 415.745C257.565 417.639 255.979 419.034 254.033 420.747C252.584 419.48 251.193 418.264 249.357 416.66C249.357 419.475 249.357 421.939 249.357 424.692C247.794 424.827 246.645 424.926 245.181 425.053C245.181 418.835 245.181 412.886 245.181 406.501C246.06 407.055 246.874 407.569 247.913 408.281Z" fill="#F1EDED"/>
        <path d="M316.996 419.386C316.994 421.506 316.994 423.236 316.994 426.246C312.423 422.438 308.648 419.293 304.317 415.684C304.317 419.046 304.317 421.897 304.317 424.819C302.662 424.819 301.5 424.819 300.357 424.819C300.357 418.555 300.357 412.514 300.357 405.686C304.728 409.823 308.526 413.419 312.789 417.455C312.789 413.804 312.789 410.755 312.789 407.413C314.193 407.284 315.335 407.179 316.997 407.027C316.997 411.173 316.997 415.085 316.996 419.386Z" fill="#F1EDED"/>
        <path d="M289.231 408.011C288.537 409.21 287.971 410.549 287.12 410.766C285.582 411.158 283.837 410.677 282.251 410.963C281.39 411.118 280.678 412.104 279.899 412.715C280.108 413.034 280.316 413.353 280.524 413.672C282.932 413.672 285.341 413.672 288.043 413.672C288.195 415.045 288.322 416.192 288.493 417.744C285.767 417.744 283.24 417.744 280.757 417.744C280.413 420.923 280.413 420.923 288.869 421.233C288.869 422.439 288.869 423.666 288.869 425.084C284.687 425.084 280.528 425.084 276.198 425.084C276.198 418.952 276.198 412.992 276.198 406.014C280.604 406.565 284.918 407.105 289.231 408.011Z" fill="#F1EDED"/>
        <path d="M179.267 419.538C177.31 419.704 175.686 419.828 173.895 419.966C173.784 421.488 173.678 422.953 173.547 424.769C172.443 424.862 171.303 424.959 169.861 425.082C169.861 419.021 169.861 413.217 169.861 406.923C172.313 406.923 174.86 406.874 177.405 406.935C180.769 407.016 183.725 407.898 184.447 411.748C185.193 415.728 183.451 418.312 179.267 419.538ZM173.711 414.103C173.511 417.265 175.972 416.368 177.273 415.998C178.406 415.676 179.212 414.204 180.163 413.241C178.843 412.367 177.63 411.172 176.181 410.695C173.893 409.941 173.491 411.516 173.711 414.103Z" fill="#FDFCF7"/>
        <path d="M196.899 423.785C195.222 424.615 193.724 425.143 192.226 425.671C191.969 425.368 191.712 425.064 191.455 424.761C194.589 418.715 197.723 412.669 201.095 406.164C204.375 412.743 207.388 418.787 210.191 424.41C205.702 424.092 201.39 423.788 196.899 423.785Z" fill="#F1EDED"/>
        <path d="M219.972 406.778C222.112 409.082 223.949 411.34 225.783 413.595C228.435 410.883 229.125 405.322 235.202 407.112C232.589 412.903 226.153 416.933 227.86 424.595C226.332 424.595 225.184 424.595 223.639 424.595C224.875 417.326 219.135 413.116 216.115 407.149C217.403 406.997 218.535 406.864 219.972 406.778Z" fill="#F1EDED"/>
        <path d="M341.696 408.226C342.002 413.241 337.892 409.956 336.18 411.913C336.18 415.926 336.18 420.365 336.18 424.946C334.759 424.946 333.616 424.946 332.185 424.946C332.185 420.41 332.185 416.095 332.185 411.444C330.364 411.31 328.8 411.194 326.766 411.045C326.664 409.878 326.554 408.623 326.366 406.475C331.789 406.967 336.737 407.416 341.696 408.226Z" fill="#E5E4E2"/>
        <path d="M104.644 126.615C105.086 125.041 105.521 123.853 105.956 122.666C106.407 122.806 106.858 122.947 107.309 123.087C107.309 124.965 107.309 126.843 107.309 129.018C109.523 129.018 111.495 129.018 114.074 129.018C113.886 134.523 109.403 130.828 107.469 133.132C107.469 134.371 107.469 136.334 107.469 138.653C102.288 138.596 105.769 134.29 104.515 133.421C102.398 131.074 98.1349 134.541 97.6592 130.206C99.6182 127.621 103.956 131.694 104.644 126.615Z" fill="#F1EDED"/>
        <path d="M404.727 124.039C404.759 125.88 404.759 127.36 404.759 129.198C406.928 129.325 408.899 129.441 410.865 129.556C411.118 131.859 411.118 131.859 404.845 132.661C404.845 134.023 404.998 135.481 404.778 136.881C404.674 137.541 403.855 138.089 403.36 138.688C402.995 138.102 402.392 137.545 402.315 136.923C402.153 135.604 402.266 134.252 402.266 133.199C400.419 130.985 396.076 134.554 395.596 129.574C397.775 129.461 399.754 129.359 402.087 129.239C402.158 127.658 402.207 126.203 402.293 124.75C402.404 122.878 403.067 122.181 404.727 124.039Z" fill="#F1EDED"/>
        <path d="M94.9616 324.437C93.7022 322.88 92.6903 321.153 91.6318 319.147C95.1797 319.066 95.8469 321.229 94.9616 324.437Z" fill="#150C17"/>
        <path d="M91.661 318.589C90.6086 317.941 89.5868 316.971 88.4629 315.754C89.471 316.427 90.5814 317.347 91.661 318.589Z" fill="#150C17"/>
        <path d="M173.709 413.744C173.491 411.516 173.893 409.941 176.181 410.695C177.631 411.172 178.844 412.367 180.163 413.24C179.212 414.204 178.406 415.675 177.273 415.998C175.972 416.368 173.511 417.265 173.709 413.744Z" fill="#1A121C"/>
      </g>
      <defs>
        <clipPath id="clip0_17996_8007">
          <rect width="526.855" height="441.641" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</div>

</template>

<script>
import axios from "axios";
import {v4 as UUID} from "uuid";
import ChangeLanguageModal from "@/public/components/modals/ChangeLanguageModal";
import NewThemeSwitch from "@/public/components/elements/NewThemeSwitch";
import LinesBackground from "@/public/components/elements/LinesBackground";
import NButton from "@/public/components/common/NButton";
import {mapState} from "vuex";
import LanguageSwitcher from "@/public/components/common/LanguageSwitcher";
import {lkLogoLoader} from "@/public/utils/logo-loader";

export default {
    name: "ApolloLoginConfirm",
  components: {LanguageSwitcher, NButton, LinesBackground, Logo: lkLogoLoader(), NewThemeSwitch, ChangeLanguageModal},
  data() {
        return {
            code: '',
            pending: false,
            twoFactorCode: '',
            errorCode: '',
            errorMsg: ''
        };
    },
    methods: {
        async onConfirmVerification() {
          if(this.pending) {
            return;
          }

            this.pending = true;

            if (this.twoFactorCode.length < 6) {
                this.errorCode = -1
                this.errorMsg = this.$t('two-fa-confirmation.error_length')
                this.pending = false;
                return
            }

            try {
              window.$$beforeLoginEventTrigger = false;

                const {data} = await axios.post('/public-api/login/2fa', {
                    code: this.twoFactorCode,
                  rid: UUID(),
                });


                if(!data.success) {
                    /*
                    TWO_FA_CODE_REQUIRED: 3002,
                    TWO_FA_CODE_INCORRECT: 3003,
                    * */
                  this.errorCode = data.code
                    switch (data.code) {
                        case 3002:
                            this.errorMsg = this.$t('authorization.code-not-entered')
                            break;
                        case 3003:
                          this.errorMsg = this.$t('authorization.code-not-valid')
                            break;
                        default:
                            break;
                    }

                  this.pending = false;
                } else {
                    // this.$store.commit('app/setAuthTwoFa', true);
                    // await this.$store.dispatch('app/init', null);

                    // this.$router.push({name: 'dashboard'});

                  if(window.$$beforeLoginEventTrigger) {
                  } else {
                    const timer = setTimeout(() => {
                      window.location.href = window.location.href+'';
                    }, 5000);

                    window.$$beforeLoginEventTrigger = () => {
                      clearTimeout(timer);

                      this.pending = false;
                    };
                  }
                }

            } catch (e) {
                this.pending = false;

                await new Promise(r => setTimeout(r, 1000));

                return this.onSubmit();
            }
        }
    },
}
</script>

<style lang="scss" scoped>
* {
  transition: all .2s ease;
}
.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  svg {
    width: 100%;
  }
}
.forgotten-password {
  color: #07ACFF;
  font-family: $Gilroy;
  font-size: 18px;
  margin-top: 10px;
  font-weight: 500;
  cursor: pointer;
}
.password-modal {
  font-family: $Gilroy;
  max-width: 640px;
  padding: 30px;
  background: var(--new-front-main-bg);
  border-radius: 30px;
  font-weight: 500;
  @media screen and (max-width: 576px) {
    border-radius: 20px;
    padding: 20px;
  }
  &__title {
    font-size: $h1;
    color: #000000;
    @media screen and (max-width: 576px) {
      font-size: $h2;
    }
  }
  &__secondaryDesc {
    margin-top: 10px;
    font-size: 18px;
    color: #000000;
    margin-bottom: 5px;
    @media screen and (max-width: 576px) {
      font-size: 14px;
    }
  }
  &__desc {
    font-size: 16px;
    color: #BE9B40;
    margin-bottom: 50px;
    border-radius: 30px;
    @media screen and (max-width: 576px) {
      font-size: 13px;
    }
  }
  &__wrapper {
    position: absolute;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    background: rgba(0,0,0,.4);
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100vw;
  height: 100vh;
  background: #000000;
}
.login {
  &__wrapper {
    font-family: 'Gilroy';
    background: #ffffff;
    height: 100vh;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  &-form {
    &__title {
      font-size: 36px;
      margin-bottom: 40px;
      font-weight: 500;
      color: var(--new-front-primary-font-color);
    }
    &__wrapper {
      z-index: 2;
      padding: 30px;
      background: var(--new-front-main-bg);
      border-radius: 30px;
      max-width: 640px;
      width: 100%;
    }
  }
  &-input {
    &__label {
      color: #000000;
      font-size: 18px;
      margin-bottom: 15px;
    }
    &__wrapper {
      margin-bottom: 20px;
    }
  }
  &-button {
    font-weight: 500;
    font-size: 18px;
    background: #000000;
    border-radius: 10px;
    line-height: 28px;
    color: #ffffff;
    padding: 10px;
    width: 100%;
    outline: none;
    border: none;
    margin-top: 30px;
    cursor: pointer;
  }
  &-description {
    padding: 20px;
    border-top: 1px solid #000000;
    margin-top: 40px;
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    color: var(--new-front-primary-font-color);
    &__link {
      color: #07ACFF;
    }
  }
}
.login-input {
  width: 100%;
  border-radius: 12px;
  outline: none;
  padding: 15px;
  border: 1px #000000 solid;
  font-size: 18px;
  margin-top: 10px;
  background: var(--new-front-input-bg);
  color: var(--new-front-primary-font-color);
}
.logo {
  position: absolute;
  top: 30px;
  left: 30px;
}
.linesBackground {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
.switcher {
  position: absolute;
  top: 30px;
  right: 30px;
}
.error-banner {
  margin-left: 12px;
  display: flex;
  align-items: center;
  &__icon {
    margin-right: 20px;
  }
  &__text {
    color: #BE4040;
    font-weight: 500;
    font-size: 16px;
  }
}
.twoFactor {
  z-index: 2;
  padding: 30px;
  background: var(--new-front-main-bg);
  border-radius: 30px;
  max-width: 640px;
  width: 100%;
  &__title {
    font-weight: 500;
    font-size: 36px;
    color: var(--new-front-primary-font-color);
    text-align: center;
    margin-bottom: 30px;
  }
  &__subtitle {
    font-weight: 400;
    font-size: 18px;
    color: var(--new-front-primary-label-color);
    text-align: center;
    margin-bottom: 50px;
  }
  &__btn {
    margin: 50px 0 40px 0;
  }
  &__logout {
    padding: 20px;
    border-top: 1px solid #000000;
    text-align: center;
    font-weight: 500;
    font-size: 18px;
  }
}
.lang-change-trigger {
  position: absolute;
  right: 49px;
  top: 15px;
  z-index: 11;
}
@media (max-width: 768px) {
  .login-input__wrapper {
    margin-bottom: 10px;
  }
  .login-description {
    margin-top: 15px;
  }
  .login-button {
    margin-top:  10px;
  }
  .login {
    &-description {
      font-size: 13px;
    }
    &__wrapper {
      padding: 10px;
    }
    &-form {
      &__wrapper {
        padding: 0 10px;
        border: 1px solid var(--new-front-border-color);
      }
      &__title {
        font-size: 24px;
        margin-bottom: 10px;
      }
    }
  }
  .login-input {
    font-size: 13px;
    &__label {
      font-size: 13px;
      margin-top: 10px;
    }
  }
  .error-banner {
    margin-left: 12px;
    display: flex;
    align-items: center;
    &__icon {
      margin-right: 15px;
    }
    &__text {
      color: #BE4040;
      font-weight: 500;
      font-size: 13px;
    }
  }

  .logo {
    left: 10px;
    top: 10px;
  }
  .switcher {
    right: 10px;
    top: 10px;
  }
  .lang-change-trigger {
    position: absolute;
    right: 45px;
    top: 26px;
  }
}
::v-deep {
  .input-password {
    input {
      border: 1px #000000 solid !important;
    }
  }
  .base-btn {
    background: #000000;

  }
}
/* Анимации появления и исчезновения могут иметь */
/* различные продолжительности и динамику.       */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
::v-deep {
  .new-front-button {
    background: #000000;
  }
  .base-btn.primary {
    background: #000000;
  }
  .languages-modal .title {
    color: #000000;
  }
}

.mobile-logo {
  display: none;
}
.mobile-block {
  display: none;
}
@media (max-width: 768px) {
  .logo-wrapper {
    display: none;
  }
  .lang-change-trigger {
    display: none;
  }
  .mobile-logo {
    display: block;
    //position: absolute;
    //top: 15px;
    //left: 15px;
  }
  .mobile-block {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 10px 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .progress {
    display: none;
  }
  .content {
    grid-template-columns: 1fr;
  }
  .login-form__wrapper {
    border: none;
  }
  ::v-deep {
    .languages-switcher {
      position: unset;
    }
  }
}
</style>
